// Module
var code = `<i class="fa fa-sort" ng-class="{ 'fa-sort-asc' : sortIconController.reverse === 'true', 'fa-sort-desc' : sortIconController.reverse === 'false' }"> </i> `;
// Exports
module.exports = code;